import { useRef } from "react";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import { SectionHeading, Reveal } from "./Reveal";
import { PROCESS_STEPS } from "../data/content";

export const HowWeWork = () => {
  const railRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: railRef, offset: ["start 0.75", "end 0.6"] });
  const scaleY = useSpring(scrollYProgress, { stiffness: 90, damping: 24 });
  const dotTop = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" className="relative border-y hairline bg-card/30 py-24 sm:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <SectionHeading
          index="08"
          eyebrow="How we work"
          title="From idea to production."
          sub="A clear, disciplined path — the same whether we build a full product or extend your team."
        />
        <div ref={railRef} className="relative mt-16 max-w-3xl">
          <div className="absolute bottom-2 left-[7px] top-2 w-px bg-border" aria-hidden="true" />
          <motion.div
            className="absolute bottom-2 left-[7px] top-2 w-px origin-top bg-primary"
            style={{ scaleY }}
            aria-hidden="true"
          />
          <motion.div
            className="absolute left-[1px] h-[13px] w-[13px] -translate-y-1/2 rounded-full bg-primary shadow-[0_0_18px_5px_var(--green-glow)]"
            style={{ top: dotTop }}
            aria-hidden="true"
            data-testid="process-rail-glow"
          />
          <motion.div
            className="absolute left-[5px] h-[5px] w-[5px] -translate-y-1/2 rounded-full bg-[#c9f29b]"
            style={{ top: dotTop }}
            aria-hidden="true"
          />
          <div className="space-y-12">
            {PROCESS_STEPS.map((step, i) => (
              <Reveal key={step.num} delay={i * 0.06}>
                <div className="relative flex gap-6 pl-10 sm:gap-8" data-testid={`process-step-${step.num}`}>
                  <span className="absolute left-0 top-1.5 h-[15px] w-[15px] rounded-full border-2 border-primary bg-background shadow-[0_0_16px_var(--green-glow)]" aria-hidden="true" />
                  <span className="font-mono text-sm font-semibold text-primary/80">{step.num}</span>
                  <div>
                    <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight">{step.title}</h3>
                    <p className="mt-1.5 text-sm sm:text-base text-muted-foreground leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
